
import {
  Document,
  History
} from '../types';

export default function grabAllDocuments(allDocuments: Document[], allHistory: History[]) {
  let all: Document[] = [];
  allDocuments.forEach(doc => {
    all.push(doc);
  });

  allHistory.forEach(history => {
    history.documents.forEach(doc => {
      let skip = false;
      all.forEach(existingDoc => {
        if (existingDoc.id === doc.id) skip = true;
      });
      if (skip) return;
      all.push(doc);
    });
  })
  return all;
}